/**
 * Hook for creating new user via POST /api/admin/users.
 * Phone required, email optional, role always CUSTOMER.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { createAdminUser } from '../services/userManagementService';
import type { CreateAdminUserPayload } from '../services/userManagementService';

function getErrorMessage(err: unknown): string {
  const ax = err as {
    response?: { data?: { code?: string; message?: string } };
  };
  const code = ax.response?.data?.code;
  const msg = ax.response?.data?.message;
  if (code === 'PHONE_EXISTS') return 'Số điện thoại đã tồn tại';
  if (code === 'EMAIL_EXISTS') return 'Email đã tồn tại';
  return msg || 'Lỗi khi tạo người dùng';
}

export function useCreateUser(options?: {
  onSuccess?: () => void;
  onError?: (err: unknown) => void;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateAdminUserPayload) => createAdminUser(payload),
    onSuccess: (_, __, context) => {
      message.success('Tạo người dùng thành công');
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
      options?.onSuccess?.();
    },
    onError: err => {
      message.error(getErrorMessage(err));
      options?.onError?.(err);
    },
  });
}
